import React from 'react';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function ContactPage() {
  return <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-187">
      <h1 className="text-4xl md:text-6xl font-retro text-white mb-12 text-center" data-id="element-188">
        Get In Touch
      </h1>

      <div className="grid md:grid-cols-2 gap-12" data-id="element-189">
        {/* Contact Info */}
        <div className="space-y-8" data-id="element-190">
          <div className="bg-dark-card p-8 rounded-xl border border-gray-800" data-id="element-191">
            <h2 className="text-2xl font-retro text-white mb-6" data-id="element-192">Visit Us</h2>

            <div className="space-y-6" data-id="element-193">
              <div className="flex items-start" data-id="element-194">
                <MapPin className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-195" />
                <div data-id="element-196">
                  <h3 className="font-bold text-white mb-1" data-id="element-197">Location</h3>
                  <p className="text-gray-400" data-id="element-198">
                    Corner of Smith Road & East 10th Street
                    <br data-id="element-199" />
                    Bloomington, IN
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-200">
                <Phone className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-201" />
                <div data-id="element-202">
                  <h3 className="font-bold text-white mb-1" data-id="element-203">Phone</h3>
                  <p className="text-gray-400" data-id="element-204">812-334-0266</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-205">
                <Clock className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-206" />
                <div data-id="element-207">
                  <h3 className="font-bold text-white mb-1" data-id="element-208">Hours</h3>
                  <div className="text-gray-400 grid grid-cols-2 gap-4" data-id="element-209">
                    <div data-id="element-210">
                      <span className="block text-white text-sm" data-id="element-211">
                        Monday - Saturday
                      </span>
                      6:00 AM - 10:00 PM
                    </div>
                    <div data-id="element-212">
                      <span className="block text-white text-sm" data-id="element-213">Sunday</span>
                      7:00 AM - 9:00 PM
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="h-64 bg-gray-800 rounded-xl overflow-hidden relative" data-id="element-214">
            <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Map Location" className="w-full h-full object-cover opacity-50" data-id="element-215" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-216">
              <Button variant="secondary" onClick={() => window.open('https://maps.google.com', '_blank')} data-id="element-217">
                Open in Google Maps
              </Button>
            </div>
          </div>
        </div>

        {/* General Inquiry Form */}
        <div className="bg-dark-card p-8 rounded-xl border border-gray-800" data-id="element-218">
          <h2 className="text-2xl font-retro text-white mb-2" data-id="element-219">
            Send a Message
          </h2>
          <p className="text-gray-400 mb-6" data-id="element-220">
            For general inquiries only. For catering, please use our Catering
            page.
          </p>

          <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-221">
            <Input label="Name" placeholder="Your Name" data-id="element-222" />
            <Input label="Email" type="email" placeholder="your@email.com" data-id="element-223" />

            <div data-id="element-224">
              <label className="block text-sm font-medium text-gray-300 mb-1" data-id="element-225">
                Message
              </label>
              <textarea className="w-full px-3 py-2 bg-dark-lighter border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-white h-32" placeholder="How can we help?" data-id="element-226"></textarea>
            </div>

            <Button type="submit" className="w-full" data-id="element-227">
              Send Message
            </Button>
          </form>
        </div>
      </div>
    </div>;
}